<template>
  <div>
    <div>
      <!-- Breadcrumbs with home icon and links to travel services page -->
      <ol
        class="breadcrumb container d-none d-md-flex py-0"
        style="
          border-radius: 0px;
          background-color: white;
          height: 60px;
          margin: 0 auto;
        "
      >
        <li>
          <a href="/" class="has-icon icon-l text-dark">
            <i class="material-icons"></i>
            Home
          </a>
        </li>
        <li>
          <a href="/travel-services" class="text-dark"
            >Travel Services</a
          >
        </li>
        <li class="active">Trailfinders Visa Service</li>
      </ol>
    </div>
    <!-- Load page top background image with title and summary-->

    <div class="app-hero-img">
      <b-img :src="getBkgImageUrl()" alt="Trailfinders Visa Service"></b-img>
      <div class="d-flex justify-content-center" style=" z-index:5">
          <div class="caption-centered position-absolute top-40 bg-dark bg-opacity-50 p-3 justify-content-center"
               style="border-radius:20px; max-width:550px; z-index:5;">
            <div class="flex-column text-center text-light">
            <h1 class="text-light mb-2">Trailfinders Visa Service</h1>
            <h3 class="text-light fs-6">
              <span>Receive {{ getCurrency() }}20pp off visa service charges when you book your travel with Trailfinders</span>
            </h3>
          </div>
        </div>
      </div>
    </div>
    <!-- Message to click on flags for relevant country visa -->

    <div class="container p-0">

      <div class="mt-5 mb-5 mx-4">
            <h5 class="text-center">
              Trailfinders Visa Service makes arranging your visas straightforward.
              Speak to our visa experts today for information and assistance with entry requirements and travel visas.
            </h5>
            <h5 class="text-center">
              Please click on the relevant flag below for more information on visa requirements for each country.
            </h5>
      </div>
    
<!--    <div v-if="mobile===true" style="text-align:center" class="mb-4 ml-5 mr-5">-->
<!--      <span class="text-strong text-success"-->
<!--        >{{ getCurrency() }}20pp OFF Visa Service Charges</span-->
<!--      >-->
<!--      <br />-->
<!--      <span class="fs-6"-->
<!--        >when you book your travel with Trailfinders.</span-->
<!--      >-->
<!--    </div>-->

<!--    <div class="container p-0">-->
      <b-row class="justify-content-center">
        <!-- Load the flags with headers -->
        <b-card
          v-for="(d, index) in countries"
          :key="index"
          :img-src="getFlagUrl(d.title)"
          img-alt="Image"
          img-top
          tag="article" role="button"
          style="flex-basis:10rem"
          class="mb-4 mx-4 w-10 h-13rem p-0 d-block"
          @click="countryClicked(index)"
        >
          <b-card-title
           class="text-center fs-6"
            text-align="center"
            ><strong>{{ d.title }}</strong></b-card-title
          >
        </b-card>
      </b-row>
      <!-- Bottom messages -->
      <b-row class="mt-4 mb-4 justify-content-center">
        <!-- <div class="col-xs-12 col-sm-6">
          <div class="alert alert-dark has-icon icon-l">
            <i class="material-icons icon-xl">&#xE88E;</i>
            <span
              >Trailfinders has always set a policy of transparent pricing. In
              that spirit we must inform you that our visa costs can be undercut
              but NOT in our view bettered for convenience.</span
            >
          </div>
        </div> -->
        <div class="col-xs-12 col-sm-12 mb-12" style="width: 50em">
          <div class="panel panel-light">
            <div class="panel-body">
              <p>
                Trailfinders Visa Service helps clients avoid the pressure of online applications.
                Many eVisa applications now require documents and photographs to be uploaded which need to be of specific specifications.
                We can provide peace of mind by arranging it all for you, taking the stress out of your visa application.
              </p>
              <p>
                Give us a call regarding any visa application queries; we’re on hand to provide expert advice and, if you do wish to use our services, we’ll process your visas promptly and efficiently.
              </p>
              <p>
                Trailfinders clients receive a discount of {{ getCurrency() }}20 off our Service Charge per application
              </p>
              <p>
              The price you see is the price you pay.
              Our application forms clearly state the cost of each visa and clearly state Trailfinders Service Charge. There are no hidden costs.
              </p>
              We offer reasonable opening hours; either call us or come into our Visa Offices in London or Dublin.
              <p>
              Our Travel Centre details for the UK & Ireland are:
              </p>
              <br />


              <div class="col-xs-12 col-sm-5 mb-6"
                   style="float: left; margin-bottom: 1.25rem; text-align: center; margin-left: 2.5em">
                <p><b>Trailfinders Visa Service UK</b></p>

                <p>194 Kensington High Street<br />
                London W8 7RG</p>

                <p>Monday - Friday: 8am - 7pm<br />
                Saturday: 9am - 6pm<br />
                Sunday & Bank Holidays: Closed</p>

                <p>Phone: 020 7368 1504</p>
                <p>Email: visas@trailfinders.com
                </p>
              </div>

              <div class="col-xs-12 col-sm-5 mb-6"
                   style="float: left; text-align: center; margin-left: 2.5em">
                <p><b>Trailfinders Visa Service Ireland</b></p>

                <p>4-5 Dawson Street<br />
                Dublin D02 FH72</p>

                <p>Monday - Saturday: 9am - 6pm<br />
                Sunday & Bank Holidays: Closed</p>

                <p>Phone: 01 881 4949</p>
                <p>Email: visas-ireland@trailfinders.com</p>
              </div>
              <div style="clear:both;"></div>


<!--              <p>-->
<!--                You can then either collect your completed passport from our-->
<!--                <span v-if="getRegion() === 'IE'"> Dublin Travel Centre </span>-->
<!--                <span v-if="getRegion() === 'UK'">-->
<!--                  Kensington Travel Centre-->
<!--                </span>-->
<!--                or we will send it to you by secure delivery.-->
<!--              </p>-->
<!--              <br />-->
<!--              <p>-->
<!--                Importantly, the price you see is the price you pay, we don’t-->
<!--                charge any extra to securely send your passport back to you, VAT-->
<!--                is included.-->
<!--              </p>-->
<!--              <br />-->
<!--              <p>-->
<!--                If you have booked your flights or holiday with Trailfinders you-->
<!--                will benefit from a {{ getCurrency() }}20 discount from our Visa-->
<!--                Service charge. Please ensure you read carefully the Visa form-->
<!--                guidelines before completing the application in order to prevent-->
<!--                errors.-->
<!--              </p>-->
            </div>
          </div>
        </div>
      </b-row>
    </div>
  </div>
</template>

<script>
import { getPageData } from "@/services/api.js";

// `https://cdn.trailfinders.com/static/codesource/img/visas/passport-banner.jpg`
// `https://cdn.trailfinders.com/images/261776/ire%20passport_eh_retouch.jpg?width=1500`,

export default {
  data() {
    return {
      meta: {
        loaded: true,
      },
      passportSectionComplete: false,
      mobile: window.innerWidth <= 700,
      countries: [],
      images: [
        `https://cdn.trailfinders.com/images/3598676/convertkit-htqzns-rx7w-unsplash.jpg?width=1500`,
        `https://cdn.trailfinders.com/images/261776/ire%20passport_eh_retouch.jpg?width=1500`,
      ],
    };
  },
  created() {
    addEventListener("resize", () => {
      this.mobile = innerWidth <= 700;
    });
  },
  mounted() {
    this.meta.loaded = true;
    this.getPageData();
  },

  methods: {
    getFlagUrl(title) {
      let country = title.split(" ")[0];
      country = country === "Australian" ? "Australia" : country;
      country =
        country === "Easter" ? "Easter_Island_Online_Registration" : country;
      country = country === "New" ? "New_Zealand_ETA" : country;
      country = country === "USA" ? "USA_ESTA" : country;
      country = country === "Sri" ? "Sri_Lanka" : country;
      country = country === "Gap" ? "Gap_Year_and_Student_Travel" : country;
      country = country === "Indian" ? "India" : country;
      return `https://cdn.trailfinders.com/static/codesource/img/visas/flags/${country}.png`;
    },
    async getPageData() {
      const referer = window.siteVar.referer;
      const countriesData = await getPageData(referer);
      this.countries = countriesData;
      this.countries = this.countries.filter((item) => {
        if (referer === item.visa_code_link.split("/")[3].substring(0, 2)) {
          return item;
        }
      });
      this.meta.loaded = true;
    },
    countryClicked(ind) {
      const country = this.countries[ind].title.split(" ")[0]
      if(country === 'Cuba'){
        const cubanVisaUrl = `https://www.trailfinders.${this.getUrlDomain(this.getRegion())}/visas/cuba#/`
        window.location.href = cubanVisaUrl;
      } else {
        this.$router.push({
          name: "country",
          params: {
            id: this.countries[ind]["@unid"],
            link: this.countries[ind].visa_code_link.split("/").pop(),
            title: this.countries[ind]["$13"].split("^").pop(),
          },
        });
      }
    },
    getBkgImageUrl() {
      return this.getRegion() === "UK" ? this.images[0] : this.images[1];
    },
    getCurrency() {
      let currency = "£";
      if (this.getRegion()) {
        currency = window.siteVar.referer === "IE" ? "€" : currency;
      }
      return currency;
    },
    getRegion() {
      let region = "UK";
      if (window.siteVar.referer) {
        region = window.siteVar.referer;
      }
      return region;
    },
    getUrlDomain(region) {
      if(region){
        return region === 'IE' ? "ie" : "com";
      }else{
        return 'com'
      }
    }
  },
};
</script>